import { Alert, Button } from "@mui/material";
import { Checkbox, Grid, Paper } from "@mui/material";
import { useState, useEffect, useCallback, useContext, useMemo, Suspense } from "react";
import { CustomInput } from "../../../../../shared/CustomInput";
import { CoveredDependents } from "../../../../../shared/enrollment/coveredDependents";
import PlanActions from "../../../../../shared/enrollment/planActions/PlanActions";
import PlanHeader from "../../../../../shared/enrollment/planCode/PlanHeader";
import {
	AuthContext,
	GroupEnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../contexts";
import { CoverageDetails } from "../../../../../shared/enrollment";
import AccessDetails from "./AccessDetails";
import { PlanFormProps } from "../../../../../../types/components/enrollmentProps.types";
import { PremiumRateCoverage } from "../../../../../../types/plan.types";
import { numberToDollarStr } from "../../../../../../utils/commonFunctions/dollar";
import { dateTimeZoneConverter, manualDateComparator } from "../../../../../../utils/commonFunctions/date";
import { getClinicCardEligibleDependents } from "../../../../../../utils/commonFunctions/groupEnrollment/eligibleDependents";
import { Member } from "../../../../../../types/employee.types";
import { CommonDetails, StandardDetails } from "../../../../../../types/enrollment.types";
import { AddEnrollmentPayload } from "../../../../../../utils/api/enrollment/enrollment";
import { getCurrentDate } from "../../../../../../utils/commonFunctions/date";
import { useHistory, useLocation } from "react-router-dom";
import { api } from "../../../../../../utils/api";
import { ClinicCardDisclaimerTable, DisclaimerTable, LazyCustomFormDialog } from "../../../../../shared";
import { generateClinicCardWaiveEnrollmentPayload } from "../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { CustomFormDialogType } from "../../../../../../types/components/dialogProps.types";
import { trackPromise } from "react-promise-tracker";
import ExistsEnrollmentModel from "../../../../../shared/existsMemberModel/ExistsEnrollmentModel";
import ExistsDependentModel from "../../../../../shared/existsMemberModel/ExistDependentModel";

const ClinicCardForm = ({
	dependents,
	isActiveEnrollment,
	getEnrollmentInitData,
	openEnrollment
}: PlanFormProps): JSX.Element => {
	const [coverageDetails, setCoverageDetails] = useState([]);
	const [hasPTINHealthPlan, setHasPTINHealthPlan] = useState<boolean | null>(null);
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const { theme } = useContext(ThemeContext);
	const { setCurrentEnrollment } = useContext(GroupEnrollmentContext);
	const [enrollmentStandardDetails, setEnrollmentStandardDetails] = useState<StandardDetails[]>([]);
	const [dependentPremium, setDependentPremium] = useState<number>(0);
	const [totalPremium, setTotalPremium] = useState<number>(0);
	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const [isModelOpen, setIsModelOpen] = useState(false);
	const [isDependentExists, setIsDependentExists] = useState(false);
	const { paycheck } = useContext(PaycheckContext);
	const [emplyoeePremium, setEmployeePremium] = useState<number>(0);
	const { member } = useContext(AuthContext);
	const [coveredDependents, setCoveredDependents] = useState<Member[]>([]);
	const location = useLocation();
	const history = useHistory();
	const [waiveReason, setWaiveReason] = useState("");
	const [isWaiveEnrollmentTriggered, setIsWaiveEnrollmentTriggered] = useState(false);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const { groupOwner } = useContext(GroupOwnerContext);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || openEnrollment === null) {
			return;
		}
		const { standardDetails, commonDetails } = generateClinicCardWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveReason
		);

		if (isActiveEnrollment) {
			// console.log("isActiveEnrollment", isActiveEnrollment);
			commonDetails.enrollment_status = "WAIVED - WAITING FOR APPROVAL";
			// debugger;
		}

		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: { ...commonDetails, agent_id: groupOwner && groupOwner._id ? groupOwner._id : null }
		};
		const response = await trackPromise(api.enrollment.addEnrollment(enrollmentPayload));
		const step = urlSearchParams.get("step");
		getEnrollmentInitData(false);
		history.push(`?step=${step}&stage=2`);
	}, [getEnrollmentInitData, history, member, openEnrollment, urlSearchParams, waiveReason]);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							// handleWaiveEnrollment();
							setIsWaiveEnrollmentTriggered(true);
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const checkMemberEnrollment = async (member: Member) => {
		const selectedMemberSSN = member?.SSN;
		const employee_SSN = member?.employee_SSN;
		const payload = {
			member_SSN: selectedMemberSSN,
			employee_SSN: employee_SSN
		};
		// console.log("selectedMemberSSN", selectedMemberSSN);
		// console.log("PAYLOADFORTHEEMPLOYEECHECK-->", member.employee_SSN);
		if (!selectedMemberSSN) {
			console.error("No SSN found");
			return;
		}

		try {
			// console.log("APIPAYLOAD--->", selectedMemberSSN);

			const response = await api.member.getExistsMemberEnrollemnt(payload);
			if (response) {
				setIsDependentExists(true);
				setExistsDependentData(response.member);
				setIsModelOpen(true);
				return true;
			}
			// console.log("APIRESPONSEFORTHEHEALTH", response);
		} catch (err) {
			console.error("Error:", err);
		}
	};

	const handleSelectDependent = useCallback(async (event: React.ChangeEvent<HTMLInputElement>, dependent: Member) => {
		const { checked } = event.target;
		if (checked === true) {
			await checkMemberEnrollment(dependent);
			setCoveredDependents((prevCoveredDependents: Member[]) =>
				Object.assign([], [...prevCoveredDependents, dependent])
			);
		} else {
			setIsDependentExists(false);
			setCoveredDependents((prevCoveredDependents: Member[]) => {
				const _selectedDependents = prevCoveredDependents.filter(
					(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
				);
				return _selectedDependents;
			});
		}
	}, []);

	const getPremiumRateByFixed = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = coverageCode.monthly_premium as number;
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = coverageCode.weekly_premium as number;
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getPremiumRateByPercentage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = (basePayRate * ((coverageCode.monthly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.monthly_maximum_premium as number)) {
					premiumAmount = coverageCode.monthly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.monthly_minimum_premium as number)) {
					premiumAmount = coverageCode.monthly_minimum_premium as number;
				}
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = (basePayRate * ((coverageCode.weekly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.weekly_maximum_premium as number)) {
					premiumAmount = coverageCode.weekly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.weekly_minimum_premium as number)) {
					premiumAmount = coverageCode.weekly_minimum_premium as number;
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const calculatePremiumByCoverage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (openEnrollment === null || paycheck === null) {
				return null;
			}

			let premiumAmount: number | null;
			if (coverageCode.active === false) {
				alert("Member is not covered in this plan");
				return null;
			}
			if (coverageCode.premium_type === "PERCENTAGE") {
				premiumAmount = getPremiumRateByPercentage(basePayRate, coverageCode);
			} else if (coverageCode.premium_type === "FIXED") {
				premiumAmount = getPremiumRateByFixed(basePayRate, coverageCode);
			} else {
				alert("Invalid premium type");
				return null;
			}
			return premiumAmount;
		},
		[getPremiumRateByFixed, getPremiumRateByPercentage, openEnrollment, paycheck]
	);

	const getPremiumAmount = useCallback(
		(premiumRateCoverage: PremiumRateCoverage): string => {
			let premiumAmount = "";
			if (paycheck) {
				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = `${numberToDollarStr(Number(premiumAmount))}`;
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = premiumAmount + "%";
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getCoverageDetails = useCallback(() => {
		const _coverageDetails: any[] = [];
		if (openEnrollment === null || paycheck === null) {
			return;
		}
		const {
			plan: { coverage }
		} = openEnrollment;
		if (coverage.EE.active === true) {
			const premiumAmount = getPremiumAmount(coverage.EE);

			_coverageDetails.push({
				coverage: "Employee Only",
				premiumAmount
			});
		}
		if (coverage.ED.active === true) {
			const premiumAmount = getPremiumAmount(coverage.ED);
			_coverageDetails.push({
				coverage: "Employee with Dependents",
				premiumAmount
			});
		}
		setCoverageDetails(Object.assign([], _coverageDetails));
	}, [getPremiumAmount, openEnrollment, paycheck]);

	useEffect(() => {
		if (openEnrollment) {
			const _eligibleDependents: Member[] = getClinicCardEligibleDependents(
				dependents,
				openEnrollment.plan.coverage
			);
			setEligibleDependents(Object.assign([], _eligibleDependents));
			getCoverageDetails();
		}
	}, [dependents, getCoverageDetails, openEnrollment]);

	const calculatePremium = useCallback(() => {
		if (openEnrollment === null || paycheck === null) {
			return null;
		}
		let basePayRate: number;
		if (paycheck?.pay_frequency === "WEEKLY") {
			basePayRate = paycheck.weekly_base_rate;
		} else if (paycheck?.pay_frequency === "MONTHLY") {
			basePayRate = paycheck.monthly_base_rate;
		} else {
			alert("Invalid Pay Frequency");
			return;
		}
		let employeePremium: number | null = 0;
		employeePremium = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.EE);
		if (employeePremium === null) {
			return;
		}
		const standardDetails: StandardDetails[] = [];
		//let _dependentPremium = 0;
		if (coveredDependents.length > 0) {
			const premiumAmount = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.ED);
			if (premiumAmount === null) {
				alert("Critical! No coverage amount for dependent");
				return;
			}
			coveredDependents.forEach((coveredDependent: Member) => {
				standardDetails.push({
					member_object_id: coveredDependent._id,
					coverage_code: "ED",
					member_SSN: coveredDependent.SSN,
					premium_amount: premiumAmount,
					is_tobacco: false
				});
			});
			setTotalPremium(premiumAmount);
		} else {
			setTotalPremium(employeePremium);
		}
		//setDependentPremium(_dependentPremium);
		//setTotalPremium(_dependentPremium + employeePremium);
		//setEmployeePremium(employeePremium);
		setEnrollmentStandardDetails(Object.assign([], standardDetails));
	}, [calculatePremiumByCoverage, coveredDependents, openEnrollment, paycheck]);

	const handleActivateButtonClick = useCallback(async () => {
		if (isDependentExists === true) {
			// alert(`Please deselect the dependent${existsDependentData.first_name} to proceed`);
			setIsDependentExistsModelOpen(true);
			return; // Exit the function early if a dependent exists
		}
		if (member === null || openEnrollment === null) {
			return;
		}

		const currentDate = new Date() as unknown as string;
		const planStartDate = openEnrollment.plan.start_date; // -1 or 0
		const planDateComparison: number = manualDateComparator(planStartDate, currentDate);

		const effectiveDate = openEnrollment.plan.auto_approve
			? planDateComparison === -1 || planDateComparison === 0
				? getCurrentDate()
				: null
			: null;

		const enrollmentCommonDetails: CommonDetails = {
			agent_id: groupOwner && groupOwner._id ? groupOwner._id : null,
			location_number: member.location.location_number,
			location_name: member.location.location_name,
			group_number: member.group_number,
			group_name: member.group.name,
			plan_object_id: openEnrollment.plan._id,
			plan_code: openEnrollment.plan.plan_code,
			plan_name: openEnrollment.plan.plan_name,
			base_plan_name: openEnrollment.plan.plan_name,
			insured_object_id: member._id,
			insured_SSN: member.SSN,
			writing_number: 0,
			unenrolled_reason: null,
			waive_reason: null,
			termination_reason: null,
			enrollment_date: getCurrentDate(),
			effective_date: effectiveDate,
			termination_date: null,
			open_enrollment_id: openEnrollment._id
		};
		const enrollmentPayload: AddEnrollmentPayload = {
			common_details: enrollmentCommonDetails,
			standard_details: [
				...enrollmentStandardDetails,
				{
					member_object_id: member._id,
					member_SSN: member.SSN,
					coverage_code: "EE",
					premium_amount:
						paycheck?.pay_frequency === "WEEKLY"
							? openEnrollment.plan.coverage.EE.weekly_premium
							: openEnrollment.plan.coverage.EE.monthly_premium,
					is_tobacco: false
				}
			]
		};
		const resp = await api.enrollment.addEnrollment(enrollmentPayload);
		const step = urlSearchParams.get("step");
		getEnrollmentInitData(false);
		history.push(`?step=${step}&stage=2`);
	}, [
		enrollmentStandardDetails,
		getEnrollmentInitData,
		history,
		isDependentExists,
		member,
		openEnrollment,
		totalPremium,
		urlSearchParams
	]);

	const getActiveHealthPlan = useCallback(async () => {
		if (paycheck && paycheck.employee_class === "PTIN - Part Time Insurance Eligible") {
			const healthPlanInstance = await api.enrollment.getActiveHealthPlan();
			if (healthPlanInstance) {
				alert("You already have Clinic Card in your active Health Plan");
				setHasPTINHealthPlan(true);
				const step = urlSearchParams.get("step");
				history.push(`?step=${step}&stage=0`);
			} else {
				setHasPTINHealthPlan(false);
			}
		}
	}, [history, paycheck, urlSearchParams]);

	const handleAddDependentClick = useCallback(() => {
		history.push("/home/add-family-member");
	}, [history]);

	useEffect(() => {
		calculatePremium();
	}, [calculatePremium, coveredDependents.length]);

	useEffect(() => {
		getActiveHealthPlan();
	}, [getActiveHealthPlan]);

	useEffect(() => {
		if (isWaiveEnrollmentTriggered) {
			handleWaiveEnrollment();
			setIsWaiveEnrollmentTriggered(false); // Reset the trigger
		}
	}, [isWaiveEnrollmentTriggered, handleWaiveEnrollment]);

	return (
		<>
			<div className="clinic-card">
				<Suspense fallback={<div />}>
					{customFormDialogProps ? (
						<LazyCustomFormDialog customFormDialogProps={customFormDialogProps} />
					) : null}
				</Suspense>
				<div className="paper-form-container">
					<Paper className="theme-border-radius paper-container" elevation={1}>
						{openEnrollment ? (
							<PlanHeader planName="Clinic Card" planCode={openEnrollment?.plan.plan_code} />
						) : null}

						<div className="theme-plan-section-margin" />
						<AccessDetails />
						<div className="theme-plan-section-margin" />
						<CoverageDetails coverageDetails={coverageDetails} />
						<div className="theme-plan-section-margin" />
						{eligibleDependents.length > 0 ? (
							<CoveredDependents
								dependents={eligibleDependents}
								handleSelectDependent={handleSelectDependent}
							/>
						) : (
							<div className="grid-actions-container">
								<div className="grid-action-margin" />
								<Button
									variant="contained"
									className="plan-action-button"
									style={{
										float: "right",
										marginBottom: "1rem",
										color: theme.button.color,
										backgroundColor: theme.button.background_color
									}}
									onClick={handleAddDependentClick}
								>
									Add Dependent
								</Button>
							</div>
						)}
						<div className="details-form-row" style={{ marginTop: "4rem", width: "100%" }}>
							<div className="details-form-label  required">Premium Amount $</div>
							<CustomInput value={numberToDollarStr(totalPremium)} disabled />
						</div>
						{openEnrollment?.plan.plan_code === "CC-PT-2023" ||
						openEnrollment?.plan.plan_code === "CC-PTIN-2023" ? (
							<div className="disclaimer-container">
								<Alert severity="warning" sx={{ fontSize: "1rem" }}>
									<div className="disclaimer-message">
										Disclaimer:{" "}
										<strong className="disclaimer">
											After May 1, 2024 all Clinic Card payroll deductions will be updated to
											reflect the new rates for the Plan year as shown below:
										</strong>
									</div>
									<ClinicCardDisclaimerTable
										payFrequency={
											paycheck?.pay_frequency === "BIWEEKLY" ? undefined : paycheck?.pay_frequency
										}
									/>
								</Alert>
							</div>
						) : null}

						<div className="theme-plan-option-content theme-plan-section-margin">
							<Checkbox defaultChecked style={{ paddingLeft: 0 }} />
							<p className="theme-plan-checkbox-label">
								<strong>
									I UNDERSTAND AND AGREE TO THE TERMS AND CONDITIONS STATED ABOVE AND AUTHORIZE
									THE&nbsp;PAYROLL DEDUCTIONS TO BE MADE AS INDICATED
								</strong>
							</p>
						</div>
						<div className="theme-plan-section-margin" />
						<Grid container className="theme-plan-section-margin">
							<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
								<div className="details-form-row">
									<div className="details-form-label  required">Signature</div>
									<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
								</div>
							</Grid>
							<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
								<div className="details-form-row">
									<div className="details-form-label  required">Date</div>
									<CustomInput value={dateTimeZoneConverter(getCurrentDate())} disabled />
								</div>
							</Grid>
						</Grid>
						<div className="theme-plan-section-margin" />
						<PlanActions
							waiveButtonCallback={handleWaiveButtonClick}
							activateButtonCallback={handleActivateButtonClick}
						/>
					</Paper>
				</div>
			</div>
			{isModelOpen && <ExistsEnrollmentModel onClose={() => setIsModelOpen(false)} />}
			{isDependentExistsModelOpen && (
				<ExistsDependentModel
					onClose={() => setIsDependentExistsModelOpen(false)}
					dependentData={existsDependentData}
				/>
			)}
		</>
	);
};

export default ClinicCardForm;
